import React from 'react';

import SlideshowUploadAccess from './SlideshowUploadAccess';
import withModal from '../../../../../../../../components/global/modal/withModal';

export const SLIDESHOW_UPLOAD_ACCESS_MODAL =
  'modal/SLIDESHOW_UPLOAD_ACCESS_MODAL';

const SlideshowUploadAccessModal = ({ actionProps, ...props }) => {
  const { currentUploadAccess, onPublish, onSuccess, isPublishing } =
    actionProps ?? {};

  return (
    <SlideshowUploadAccess
      currentUploadAccess={currentUploadAccess}
      onPublish={onPublish}
      onSuccess={onSuccess}
      isPublishing={isPublishing}
      {...props}
    />
  );
};

export default withModal(SlideshowUploadAccessModal, {
  name: SLIDESHOW_UPLOAD_ACCESS_MODAL,
  size: 'sm',
});
